import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import { Login } from "../pages/Login";
import { useAuth } from "../hooks/use-auth";
import { ProjectIdContext } from '../contexts/Project/Project';
import ChooseProject from '../pages/afterLogin/chooseProject';

function ProjectGuard(props) {
    const { children } = props;
    const auth = useAuth();
    const location = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);

    const { ProjectID } = ProjectIdContext()

    if (!ProjectID || ProjectID=='undefined') {

        return (
            <ChooseProject />
        );
    }

    return (
        <div>{children}</div>
    );
}

export default ProjectGuard;
